import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { FormSubmitButton } from './FormSubmitButton';
export function SimpleTextField() {
    const [field, meta] = useField('value');
    const error = Boolean(meta.touched && meta.error);
    return (<Fragment>
      <Menu.TextInput label={t({ message: 'Text', comment: 'Metadata: Simple text input label' })} invalid={error} {...field}/>
      <FormSubmitButton />
    </Fragment>);
}
